import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import type { OverviewCategory } from 'shared/src/api';

export const useLogClickExpandableCategoryList = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (category: OverviewCategory) => {
      logAnalyticsEvent({
        name: 'CLICK_EXPANDABLE_CATEGORY_LIST',
        analytics: { ...category.logging.analytics },
      });
    },
    [logAnalyticsEvent],
  );
};
